import { render, staticRenderFns } from "./goods_record.vue?vue&type=template&id=e90c9b1c&scoped=true&"
import script from "./goods_record.vue?vue&type=script&lang=js&"
export * from "./goods_record.vue?vue&type=script&lang=js&"
import style0 from "./goods_record.vue?vue&type=style&index=0&id=e90c9b1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90c9b1c",
  null
  
)

export default component.exports